/*
 * MDB shim for Input
 * Files currently importing this symbol from "mdbreact":
 * - src/Components/Custom/CreateModal.jsx
 * - src/Components/Custom/InlineTable.jsx
 * - src/Seating/Accounts/accountDetail.jsx
 * - src/Seating/Activities/activities-add.jsx
 * - src/Seating/Activities/activities-edit.jsx
 * - src/Seating/Activities/activitiesModal.jsx
 * - src/Seating/Contacts/contact-edit.jsx
 * - src/Seating/InventoryProduct/inventoryProductTable.jsx
 * - src/Seating/Patient/PatientViewComponents/CreateQuoteModalFromTicket.jsx
 * - src/Seating/Patient/PatientViewComponents/HomeAssessmentModal.jsx
 * - src/Seating/Patient/PatientViewComponents/attachmentsTab.jsx
 * - src/Seating/Patient/PatientViewComponents/createNoteModal.jsx
 * - src/Seating/Patient/PatientViewComponents/patientInformationTab.jsx
 * - src/Seating/Patient/patientInformationView.jsx
 * - src/Seating/Patient/patientOrderView.jsx
 * - src/Seating/PurchaseQueue/PODeliveryUpdate.jsx
 * - src/Seating/PurchaseQueue/inventoryRequestTable.jsx
 * - src/Seating/PurchaseQueue/purchaseQueueTable.jsx
 * - src/Seating/Settings/addProdcutMatrixEntry.jsx
 * - src/Seating/Settings/addProductSubType.jsx
 * - src/Seating/Settings/creditCardTypes.jsx
 * - src/Seating/Settings/deliveryAcknowledgements.jsx
 * - src/Seating/Settings/editProductSubTypes.jsx
 * - src/Seating/Settings/expenseTypes.jsx
 * - src/Seating/Settings/productTypes.jsx
 * - src/Seating/Settings/reasons.jsx
 * - src/Seating/Settings/vendor.jsx
 * - src/Seating/Users/thirdPartyUserList.jsx
 * - src/Seating/Users/userAdd.jsx
 * - src/Seating/Users/userEdit.jsx
 */

import MUICheckbox from "@mui/material/Checkbox";
import MUIRadio from "@mui/material/Radio";
import MUITextField from "@mui/material/TextField";
import MUIFormControlLabel from "@mui/material/FormControlLabel";

export default function Input({ type = "text", label, value, onChange, rows, disabled, checked, style, ...rest }) {
    if (type === "checkbox") {
        return (
            <MUIFormControlLabel
                control={
                    <MUICheckbox
                        checked={Boolean(checked ?? value)}
                        onChange={onChange}
                        disabled={disabled}
                        style={style}
                        {...rest}
                    />
                }
                label={label}
            />
        );
    }
    if (type === "radio") {
        return (
            <MUIFormControlLabel
                control={
                    <MUIRadio
                        checked={Boolean(checked ?? value)}
                        onChange={onChange}
                        disabled={disabled}
                        style={style}
                        {...rest}
                        
                    />
                }
                label={label}
            />
        );
    }

    const multiline = type === "textarea" || Number(rows) > 1;
    const valueProps = value !== undefined ? { value } : {};

    return (
        <MUITextField
            type={multiline ? undefined : type}
            label={label}
            onChange={onChange}
            multiline={multiline}
            rows={rows}
            disabled={disabled}
            style={style}
            {...valueProps}
            {...rest}
        />
    );
}
